import { CrudBuilderConfig } from '../../components/crudbuilder/models/crud-builder-config';
import ListFormatter from '../../helpers/list-formatter';
import Formatter from '../../helpers/formatter';
import { FieldConfig } from '../../components/crudbuilder/models/field-config';
import { createWork, Work } from '../../state/works';
import { DropdownFieldConfig, DropdownItem } from '@core/components/crudbuilder/models/dropdown-field-config';
import { FieldGroup } from '@core/pages/crud/dependent-fields/field-group';
import {PopularAppStatesService} from '@core/services/popular-app-states/popular-app-states.service';
import * as moment from 'moment';

export class WorksCrudBuilderConfigClass extends CrudBuilderConfig {
  singular    = 'Work';
  plural      = 'Werkgevers';
  customTitle = 'Vul hier uw huidige salaris / werkgegevens in';
  modelAlias  = 'work';
  path        = 'works';
  fields      = [
    new DropdownFieldConfig('type', 'Soort Werk', {
      contents: [
        new DropdownItem('Loondienst', 'loondienst'),
        new DropdownItem('Ondernemer', 'zakelijk')
      ]
    }),

    new FieldConfig('employee', 'string', 'Medewerker'),

    new FieldGroup('type', 'zakelijk', [
      new FieldConfig('name', FieldConfig.TYPE_ZAKELIJKSTRING, 'Naam functie'),
      new FieldConfig('start_date', FieldConfig.TYPE_ZAKELIJKTDATE, 'Datum oprichting'),
      new FieldConfig('salary', FieldConfig.TYPE_ZAKELIJKMONEY, 'Gemiddeld inkomen over afgelopen 3 jaar'),

      new FieldConfig('income_3_years_ago', FieldConfig.TYPE_ZAKELIJKMONEY, `Inkomen (${moment().subtract(3, 'years').year()})`),
      new FieldConfig('income_2_years_ago', FieldConfig.TYPE_ZAKELIJKMONEY, `Inkomen (${moment().subtract(2, 'years').year()})`),
      new FieldConfig('income_1_year_ago', FieldConfig.TYPE_ZAKELIJKMONEY, `Inkomen (${moment().subtract(1, 'years').year()})`),
    ]),

    new FieldGroup('type', 'loondienst', [
      new FieldConfig('position', FieldConfig.TYPE_LOONDIENSTSTRING, 'Functieomschrijving'),

      new FieldConfig('name', FieldConfig.TYPE_LOONDIENSTSTRING, 'Werknemer'),
      new FieldConfig('start_date', FieldConfig.TYPE_LOONDIENSTDATE, 'Datum in dienst'),
      new FieldConfig('salary', FieldConfig.TYPE_LOONDIENSTMONEY, 'Jaarsalaris (zonder vakantiegeld / eindejaarsuitkering)'),
      new FieldConfig('thirteenth_month', FieldConfig.TYPE_LOONDIENSTBOOLEAN, 'Ontvangt u een eindejaarsuitkering'),
      new FieldConfig('', FieldConfig.TYPE_LOONDIENSTVAL, 'Indien ja, hoe hoog is het percentage van de eindejaarsuitkering?'),
      new FieldConfig('holiday_pay', FieldConfig.TYPE_LOONDIENSTBOOLEAN, 'Ontvangt u vakantiegeld?'),
      new FieldConfig('', FieldConfig.TYPE_VAKANTIEGELD, 'indien ja, hoe hoog is het percentage van het vakantiegeld?'),
      new FieldConfig('contract_configuration_id', FieldConfig.TYPE_LOONDIENSTCONTRACT, 'Type contract'),
      // new FieldConfig('total_salary', FieldConfig.TYPE_LOONDIENSTSTRING, 'Totaal Jaarsalaris'),
    ]),
  ];

  readFields  = [
    new FieldConfig('name', 'string', 'Naam Werkgever'),
    new FieldConfig('employee', 'string', 'Medewerker'),
    new FieldConfig('start_date', 'date', 'Datum in dienst'),
    new FieldConfig('salary', 'money', 'Jaarsalaris (excl vakantiegeld / eindejaarsuitkering'),
    new FieldConfig('thirteenth_month', FieldConfig.TYPE_BOOLEAN, 'Krijgt u een volledige 13e maand?'),
    new FieldConfig('holiday_pay', FieldConfig.TYPE_BOOLEAN, 'Krijgt u vakantiegeld?'),
    new FieldConfig('contract', 'relation_config', 'Soort contract'),
  ];

  listView(model: Work) {
    const view = new ListFormatter()
      .fHead('Naam Werkgever', model.name)
      // .fHead('Medewerker', model.employee)
      .fSub('Salaris', Formatter.formatMoney(model.salary))
      .fP(Formatter.formatDate(model.start_date))
    ;
    return view.toString();
  }

  getModel() {
    return createWork({});
  }

  getReadTitle(model: Work) {
    return '';
  }

  private isZero(x) {
    if (!x) {
      return true;
    }

    if (parseFloat(x) == 0) {
      return true;
    }

    return false;
  }

  editPreprocess(model: Work) {
    const nm                     = {...model};
    if ( Object.keys(nm).length ) {
      if (nm.contract) {
        nm.contract_configuration_id = nm.contract.id;
      }
      console.log(this.isZero(nm.income_1_year_ago));
      if (
        this.isZero(nm.income_1_year_ago) ||
        this.isZero(nm.income_2_years_ago) ||
        this.isZero(nm.income_3_years_ago)
      ) {
        console.log('ZAKELIJK!');
        nm.type = 'loondienst';
      } else {
        nm.type = 'zakelijk';
      }
    }

    return nm;
  }

  runBeforeSavingOnAddView(model: Work, states: PopularAppStatesService) {
    model.person_id = states.account.getCached().id;
    return model;
  }

  runBeforeSavingOnEditView(model, s: PopularAppStatesService = null): any {
    if (model.type == 'loondienst') {
      model.income_1_year_ago = 0;
      model.income_2_years_ago = 0;
      model.income_3_years_ago = 0;
    }
    return super.runBeforeSavingOnEditView(model, s);
  }
}

export const WorksCrudBuilderConfig = new WorksCrudBuilderConfigClass();
